export const isDecimal = (value) => {
  if (value) {
    return !Number.isInteger(value)
  }
  return null
}
